/*
 * tp-likes.js — Merkliste (Plan 0071). ES5-IIFE, keine Abhaengigkeiten.
 *
 * Ein Zustand: sessionStorage['tp:likes'] = [{product_id, handle}]. Genau ein
 * GET pro Session (die meisten Besucher haben nichts gemerkt — der Server cacht
 * auch die leere Liste). Klick schaltet das Herz sofort um und schickt den
 * Toggle fire-and-forget; bei 409/429 wird zurueckgedreht.
 *
 * Identitaet: der Server nimmt den signierten Kunden, sonst die visitor_id aus
 * localStorage['tp:track:vid'] — die legt tp-track.js an, das vorher laeuft.
 * Login-Merge: einmal pro Konto POST /likes/claim (Marker tp:likes:claimed).
 *
 * Geraet (Plan 0071 D4): kommt im selben GET mit (sessionStorage['tp:device']),
 * PUT/DELETE /apps/storefronthub/device ueber setDevice/clearDevice. fetchShelf holt
 * die Zubehoer-Ablage (Section-Rendering-API) fuer Seite und Startseiten-Rail.
 *
 * Ereignisse: tp:likes, tp:alerts, tp:device (document).
 *
 * Oeffentliche API: window.TPLikes =
 *   { list, has, toggle, refresh, device, setDevice, clearDevice, alerts,
 *     alertFor, setAlert, clearAlert, euro, fetchShelf }.
 */
(function () {
  'use strict';
  if (window.TPLikes) { return; }

  var CFG = window.TP_LIKES_CFG || {};
  var API = '/apps/storefronthub';
  var KEY = 'tp:likes';
  var DEV_KEY = 'tp:device';
  var ALERT_KEY = 'tp:alerts';

  function url(path) {
    var vid = null;
    try { vid = localStorage.getItem('tp:track:vid'); } catch (e) {}
    return API + path + (vid ? '?visitor_id=' + encodeURIComponent(vid) : '');
  }

  var likes = null;
  function load() {
    if (likes) { return likes; }
    try { likes = JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (e) { likes = null; }
    return likes;
  }
  function save(list) {
    likes = list || [];
    try { sessionStorage.setItem(KEY, JSON.stringify(likes)); } catch (e) {}
    paint();
    document.dispatchEvent(new CustomEvent('tp:likes', { detail: likes }));
  }
  var alerts;
  function loadAlerts() {
    if (alerts) { return alerts; }
    try { alerts = JSON.parse(sessionStorage.getItem(ALERT_KEY) || '[]'); } catch (e) { alerts = []; }
    return alerts;
  }
  function saveAlerts(list) {
    alerts = list || [];
    try { sessionStorage.setItem(ALERT_KEY, JSON.stringify(alerts)); } catch (e) {}
    document.dispatchEvent(new CustomEvent('tp:alerts', { detail: alerts }));
  }
  function alertFor(variantId, productId) {
    var l = loadAlerts();
    for (var i = 0; i < l.length; i++) {
      if ((variantId && String(l[i].variant_id) === String(variantId)) || (!variantId && String(l[i].product_id) === String(productId))) { return l[i]; }
    }
    return null;
  }
  function euro(cents) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }
  var device;
  function loadDevice() {
    if (device !== undefined) { return device; }
    try { device = JSON.parse(sessionStorage.getItem(DEV_KEY) || 'null'); } catch (e) { device = null; }
    return device;
  }
  function saveDevice(dev) {
    device = dev || null;
    try { sessionStorage.setItem(DEV_KEY, JSON.stringify(device)); } catch (e) {}
    document.dispatchEvent(new CustomEvent('tp:device', { detail: device }));
  }
  function has(id) {
    var l = load() || [];
    for (var i = 0; i < l.length; i++) { if (String(l[i].product_id) === String(id)) { return true; } }
    return false;
  }

  function refresh() {
    return fetch(url('/likes'), { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : { likes: [] }; })
      .then(function (d) { saveDevice(d.device); saveAlerts(d.alerts); save(d.likes || []); return likes; })
      .catch(function () { save(load() || []); return likes; });
  }

  function paint() {
    var n = (load() || []).length;
    var btns = document.querySelectorAll('[data-tp-like]');
    for (var i = 0; i < btns.length; i++) {
      var b = btns[i], on = has(b.getAttribute('data-product-id'));
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.classList.toggle('is-on', on);
      var t = b.querySelector('[data-tp-like-txt]');
      if (t) { var want = t.getAttribute(on ? 'data-on' : 'data-off'); if (t.textContent !== want) { t.textContent = want; } }
    }
    var label = n > 99 ? '99+' : String(n);
    var badges = document.querySelectorAll('[data-tp-likes-count]');
    for (var j = 0; j < badges.length; j++) {
      // Nur bei Aenderung schreiben: paint() laeuft ueber den MutationObserver, sonst Schleife.
      if (badges[j].textContent !== label) { badges[j].textContent = label; }
      badges[j].hidden = n === 0;
    }
    document.documentElement.classList.toggle('tp-has-likes', n > 0);
  }

  function send(method, body) {
    return fetch(url('/likes'), {
      method: method, keepalive: true,
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    });
  }

  function toggle(id, handle) {
    var on = has(id);
    var l = (load() || []).filter(function (x) { return String(x.product_id) !== String(id); });
    if (!on) { l.unshift({ product_id: Number(id), handle: handle }); }
    save(l);
    if (window.TP && TP.track) { TP.track(on ? 'product_unliked' : 'product_liked', { product_id: Number(id), handle: handle }); }
    return send(on ? 'DELETE' : 'POST', { product_id: Number(id), handle: handle })
      .then(function (r) {
        if (r.ok) { return true; }
        // 409 = Liste voll, 429 = zu schnell, sonst Serverfehler: Zustand vom Server holen.
        return refresh().then(function () { return false; });
      })
      .catch(function () { return false; });
  }

  // Login-Merge (D2): Gast-Likes wandern einmalig zum Konto.
  function claim() {
    if (!CFG.customer) { return Promise.resolve(false); }
    try { if (localStorage.getItem('tp:likes:claimed') === String(CFG.customer)) { return Promise.resolve(false); } } catch (e) {}
    return fetch(url('/likes/claim'), { method: 'POST' })
      .then(function () { try { localStorage.setItem('tp:likes:claimed', String(CFG.customer)); } catch (e) {} return true; })
      .catch(function () { return false; });
  }

  document.addEventListener('click', function (ev) {
    var b = ev.target.closest && ev.target.closest('[data-tp-like]');
    if (!b) { return; }
    ev.preventDefault(); ev.stopPropagation();
    toggle(b.getAttribute('data-product-id'), b.getAttribute('data-handle'));
  }, true);

  // Zubehoer-Code kopieren (Welle 4): der Kasten kommt per Section-Rendering, sein Script liefe nicht.
  document.addEventListener('click', function (ev) {
    var b = ev.target.closest && ev.target.closest('[data-tp-copy]');
    if (!b) { return; }
    var code = b.getAttribute('data-tp-copy'), done = function () { b.textContent = 'Kopiert'; };
    if (navigator.clipboard && navigator.clipboard.writeText) { navigator.clipboard.writeText(code).then(done, function () { select(b); }); } else { select(b); }
    function select(el) { var c = el.parentNode.querySelector('code'); if (c && window.getSelection) { window.getSelection().selectAllChildren(c); } }
  });

  // Karten, die spaeter kommen (Rails, Suche, Section-Rendering): nachfaerben, gebuendelt.
  var pending = null;
  function schedulePaint() {
    if (pending) { return; }
    pending = setTimeout(function () { pending = null; paint(); }, 80);
  }
  if (window.MutationObserver) {
    new MutationObserver(schedulePaint).observe(document.documentElement, { childList: true, subtree: true });
  }

  function setDevice(dev) {
    saveDevice(dev);
    return fetch(url('/device'), {
      method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(dev)
    }).then(function (r) { if (!r.ok) { refresh(); } }).catch(function () {});
  }
  // Wunschpreis (Plan 0071 D5): nur Kunden — der Server antwortet Gaesten mit 401.
  function setAlert(a) {
    var l = loadAlerts().filter(function (x) { return String(x.variant_id) !== String(a.variant_id); });
    l.unshift({ product_id: a.product_id, variant_id: a.variant_id, target_cents: a.target_cents });
    saveAlerts(l);
    return fetch(url('/alerts'), { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(a) })
      .then(function (r) { if (!r.ok) { return refresh().then(function () { return r.status; }); } return 204; })
      .catch(function () { return 0; });
  }
  function clearAlert(variantId) {
    saveAlerts(loadAlerts().filter(function (x) { return String(x.variant_id) !== String(variantId); }));
    return fetch(url('/alerts'), { method: 'DELETE', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ variant_id: Number(variantId) }) }).catch(function () {});
  }
  function clearDevice() {
    saveDevice(null);
    return fetch(url('/device'), { method: 'DELETE' }).catch(function () {});
  }
  // Zubehoer-Ablage eines Geraets als .tp-dsh-Element; null, wenn es nichts gibt.
  function fetchShelf(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '?section_id=tp-device-shelf')
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) { return new DOMParser().parseFromString(html, 'text/html').querySelector('.tp-dsh'); })
      .catch(function () { return null; });
  }

  function boot() {
    if (load()) { paint(); }
    claim().then(function (claimed) { if (claimed || !load()) { refresh(); } });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }

  window.TPLikes = {
    list: function () { return (load() || []).slice(); }, has: has, toggle: toggle, refresh: refresh,
    device: loadDevice, setDevice: setDevice, clearDevice: clearDevice,
    alerts: loadAlerts, alertFor: alertFor, setAlert: setAlert, clearAlert: clearAlert, euro: euro,
    fetchShelf: fetchShelf
  };
})();
